import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Slider from '@mui/material/Slider';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from "@mui/material/Paper";
import Icn from "../Icn";
import {register, unregister} from "../../domain/socketSlice";
import TestSensorGrid from "./TestSensorGrid";
import CopyToClipboard from "../CopyToClipboard";

const WrapperStyled = styled.div`
    height: 100%;
    margin: 10px;
    position: relative;
`;

const SensorBoxStyled = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

const SensorInfoStyled = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 2;
`;

const SensorDataItemStyled = styled.div`
    position: absolute;
    cursor: default;
    display: grid;
    align-content: center;
    justify-content: center;

    .hoveredItem {
        display: none;
        font-size: 22px;
        position: absolute;
        top: 1px;
    }

    &:hover {
        .hoveredItem {
            display: block;
        }
    }
`;

const ActionsStyled = styled.div`
    margin: 10px;
    position: relative;
    width: 450px;
    display: grid;
    grid-template-columns: 400px 400px 100px 140px;
    grid-gap: 50px;
`;

const CopyWrapperStyled = styled.div`
    display: inline-block;
    margin-right: 25px;
    position: relative;

    .lable {
        color: rgb(99, 115, 129);
        font-size: 12px;
    }
`;

const CopyWrapperGroupStyled = styled.div`

`;

const SensorTestDialog = ({sensor, onClose, siteId, edgeId}) => {
    const ref = useRef(null);
    const boxRef = useRef(null);

    const [sensorData, s_sensorData] = useState([]);
    const [sensorDataObj, s_sensorDataObj] = useState({});
    const [pauseGetData, s_pauseGetData] = useState(false);


    const [calculating, s_calculating] = useState(false);
    const [dragging, s_dragging] = useState(false);
    const [startPos, s_startPos] = useState({ x: 0, y: 0 });
    const [endPos, s_endPos] = useState({ x: 0, y: 0 });
    const [calculatedValueToDisplay, s_calculatedValueToDisplay] = useState(null);


    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);

    const [value, s_value] = useState(10);
    const [color, s_color] = useState(0);
    const [hoveredItem, s_hoveredItem] = useState(null);
    const [hoveredItemCube, s_hoveredItemCube] = useState(null);

    const sensorId = sensor.sensorId;
    const eventName = `test-sensor`;

    const getColor = val => {
        let result = '#33FF9F';
        const colorScale = color ? color / 500 + 1 : 1;

        const calculatedVal = val * colorScale;
        if (calculatedVal <= 1000) {
            const pecent = parseInt((calculatedVal / 100).toString(), 10);
            result = shadeColor('#33FF9F', pecent);
        }

        if (calculatedVal > 1000 - color) {
            const pecent = parseInt(((calculatedVal - 1000) / 100).toString(), 10);
            result = shadeColor('#FFA500', pecent);
        }
        if (calculatedVal > 2000 - color) {
            const pecent = parseInt(((calculatedVal - 2000) / 100).toString(), 10);
            result = shadeColor('#339CFF', pecent);
        }
        if (calculatedVal > 3000 - color) {
            const pecent = parseInt(((calculatedVal - 3000 / 100)).toString(), 10);
            result = shadeColor('#FF5E33', pecent);
        }
        return result;
    };

    function shadeColor(color, percent) {

        let R = parseInt(color.substring(1, 3), 16);
        let G = parseInt(color.substring(3, 5), 16);
        let B = parseInt(color.substring(5, 7), 16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        R = Math.round(R);
        G = Math.round(G);
        B = Math.round(B);

        const RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        const GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        const BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
    }


    useEffect(() => {
        register(eventName);
        window.addEventListener(eventName, onData);


        return () => {
            unregister(eventName);
            window.removeEventListener(eventName, onData);
        };
    }, []);

    // useEffect(() => {
    //     api({
    //         type: 'testSensor', data: {
    //             siteId,
    //             sensorId,
    //             edgeId,
    //             enabled: true
    //         }
    //     });
    //
    //     return () => {
    //         api({
    //             type: 'testSensor', data: {
    //                 siteId,
    //                 sensorId,
    //                 edgeId,
    //                 enabled: false
    //             }
    //         });
    //     };
    // }, []);

    // console.log();

    useEffect(() => {
        if (ref.current && ref.current.offsetWidth) {
            s_height(ref.current.offsetHeight);
            s_width(ref.current.offsetWidth);
        }
    }, [ref.current, ref.current?.offsetHeight]);

    const onData = async (sensorData) => {
        const {data} = sensorData.detail;

        s_sensorDataObj(prevState => {
            const copyOfPrevState = {...prevState};
            for (let i = 0; i < data.length; i++) {
                const datum = data[i];
                if (datum.v === 0) {
                    if (copyOfPrevState[`${datum.x}_${datum.y}`]) {
                        delete copyOfPrevState[`${datum.x}_${datum.y}`];
                    }
                } else {
                    copyOfPrevState[`${datum.x}_${datum.y}`] = datum;
                }
            }
            if (!window.pauseGetData) {
                s_sensorData(Object.values(copyOfPrevState));
            }
            return copyOfPrevState;
        });
    };
    const sliderChange = (e, val) => {
        s_value(val);
    };

    const handleMouseDown = (e) => {
        if(!calculating){
            return;
        }
        s_dragging(true);
        const { clientX, clientY } = e;
        const rect = boxRef.current.getBoundingClientRect(); // Get the bounding rect of the target element
        const offsetX = clientX - rect.left; // Calculate the offset of the click inside the target element
        const offsetY = clientY - rect.top;
        s_startPos({ x: offsetX, y: offsetY });
        s_endPos({ x: offsetX, y: offsetY });
    };

    const handleMouseMove = (e) => {
        if(!calculating){
            return;
        }
        if (dragging) {
            const { clientX, clientY } = e;
            const rect = boxRef.current.getBoundingClientRect(); // Get the bounding rect of the target element
            const offsetX = clientX - rect.left; // Calculate the offset of the mouse inside the target element
            const offsetY = clientY - rect.top;
            s_endPos({ x: offsetX, y: offsetY });
        }
    };

    const handleMouseUp = () => {
        if(!calculating){
            return;
        }
        s_dragging(false);

        const xmin = (startPos.x / width) * 100;
        const xmax = (endPos.x / width) * 100;
        const ymin = (startPos.y / height) * 100;
        const ymax = (endPos.y / height) * 100;
        calculateValues({ xmin, xmax, ymin, ymax });
    };

    const calculateValues = ({xmin, xmax, ymin, ymax}) => {
        let calculatedValue = 0;
        const boxWidth = xmax - xmin;
        const boxHeight = ymax - ymin;


        for (let i = 0; i < sensorData.length; i++) {
            const element = sensorData[i];
            const positionX = element.x * 100 / sensorWidth;
            const positionY = element.y * 100 / sensorHeight;

            const absX = xmin + (boxWidth * positionX / 100);
            const absY = ymin + (boxHeight * positionY / 100);

            if (xmin <= absX && absX <= xmax && ymin <= absY && absY <= ymax) {
                calculatedValue += element.v;
            }
        }

        s_calculatedValueToDisplay(calculatedValue);
    };


    const sensorWidth = sensor.sensor.width / 0.8;
    const sensorHeight = sensor.sensor.height / 0.8;

    let divider = width / sensorWidth;
    if (sensorHeight > sensorWidth) {
        divider = height / sensorHeight;
    }

    let fontSize = 10;

    let boxWidth = 0;
    let boxHeight = 0;
    if (sensorWidth > sensorHeight) {
        boxWidth = "95%";
        boxHeight = sensorHeight * divider;
    } else {
        boxHeight = '100%';
        boxWidth = sensorWidth * divider;
    }

    fontSize = width / sensorWidth / 2.4;

    const numberOfCubes = sensorWidth * sensorHeight;

    const getCubePoints = () => {
        if (hoveredItemCube) {
            const x = hoveredItemCube?.y;
            const y = hoveredItemCube?.x;
            return {x, y};
        }
        return {x: 0, y: 0};
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen={true}>

            <DialogTitle id="alert-dialog-title">
                <Icn style={{position: 'relative', top: 4}}>scienceIcon</Icn>
                <CopyWrapperGroupStyled>
                    <CopyWrapperStyled>
                        <span className="val">Sensor test[{sensor?.sensor?.boardId}]</span>
                    </CopyWrapperStyled>
                    <CopyWrapperStyled>
                        <span className="lable">ID:</span>
                        <span className="val">{sensor?.sensorId}</span>
                        <CopyToClipboard
                            textToCopy={sensor?.sensorId}
                        />
                    </CopyWrapperStyled>
                    <CopyWrapperStyled>
                        <span className="lable">MAC:</span>
                        <span className="val">{sensor?.sensor?.mac}</span>
                        <CopyToClipboard
                            textToCopy={sensor?.sensor?.mac}
                        />
                    </CopyWrapperStyled>

                    {sensor?.sensor?.ip && (
                        <CopyWrapperStyled>
                            <span className="lable">IP:</span>
                            <span className="val">{sensor?.sensor?.ip}</span>
                            <CopyToClipboard
                                textToCopy={sensor?.sensor?.ip}
                            />
                        </CopyWrapperStyled>
                    )}
                </CopyWrapperGroupStyled>
            </DialogTitle>
            <DialogContent>
                <ActionsStyled>
                    <div>
                        <span>Filter value from 0 to 4000, current: {value}</span>
                        <Slider
                            defaultValue={value}
                            aria-label="Default"
                            valueLabelDisplay="auto"
                            value={value}
                            onChange={sliderChange}
                            max={4000}
                            min={0}
                            step={50}
                        />
                    </div>
                    <div>
                        <span>Colors, current: {color}</span>
                        <Slider
                            defaultValue={0}
                            aria-label="Default"
                            valueLabelDisplay="auto"
                            value={color}
                            marks
                            onChange={(e, val) => s_color(val)}
                            max={2000}
                            min={0}
                            step={500}
                        />
                    </div>
                    <div>
                        <Button onClick={() => {
                            if (pauseGetData) {
                                s_pauseGetData(false);
                                window.pauseGetData = false;
                            } else {
                                s_pauseGetData(true);
                                window.pauseGetData = true;
                            }
                        }} variant="contained">{pauseGetData ? "Resume" : "Pause"}</Button>
                    </div>
                    <div>
                        <Button onClick={() => {
                            if (calculating) {
                                s_calculating(false);
                                s_pauseGetData(false);
                                window.pauseGetData = false;
                                s_startPos({x: 0, y: 0});
                                s_endPos({x: 0, y: 0});
                            } else {
                                s_calculating(true);
                                s_pauseGetData(true);
                                window.pauseGetData = true;
                            }
                        }} variant="contained">{!calculating ? "Calculate" : "Calculating"}</Button>
                    </div>
                </ActionsStyled>
                <WrapperStyled ref={ref} style={{height: boxHeight, width: boxWidth, margin: 0, padding: 0}}>
                    <SensorInfoStyled>
                        {hoveredItemCube && (
                            <span>Point: x: {getCubePoints().x}, y: {getCubePoints().y}, </span>
                        )}
                        {hoveredItem && (
                            <span>V: {hoveredItem.v}, x: {hoveredItem.x}, y: {hoveredItem.y}, </span>
                        )}
                        Width: {sensorWidth}, Height: {sensorHeight}, Total Points: {sensorData?.length || 0}
                        {calculatedValueToDisplay !== null && (
                            <span>, Total Value: {calculatedValueToDisplay}</span>
                        )}
                    </SensorInfoStyled>
                    <SensorBoxStyled
                        ref={boxRef}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        onMouseMove={handleMouseMove}
                    >
                        {calculating && (
                            <div
                                className="square"
                                style={{
                                    position: 'absolute',
                                    border: '2px solid #d7d7e4',
                                    backgroundColor: 'rgba(0, 0, 255, 0.1)',
                                    left: startPos.x,
                                    top: startPos.y,
                                    width: endPos.x - startPos.x,
                                    height: endPos.y - startPos.y,
                                }}
                            />
                        )}
                        <TestSensorGrid
                            xItems={sensorWidth}
                            yItems={sensorHeight}
                            numberOfCubes={numberOfCubes}
                            divider={divider}
                            hoveredItemCube={(x, y) => s_hoveredItemCube({x, y})}
                        />
                        <Paper elevation={3} style={{height: "100%"}}>
                            {sensorData.map((data, idx) => {
                                let positionX = data.x * 100 / sensorWidth;
                                let positionY = data.y * 100 / sensorHeight;
                                const color = getColor(data.v);

                                if (data.v < value) {
                                    return null;
                                }

                                return (
                                    <SensorDataItemStyled
                                        key={idx}
                                        onMouseEnter={() => {
                                            s_hoveredItem(data);
                                        }}
                                        onMouseLeave={() => {
                                            s_hoveredItem(null);
                                        }}
                                        style={{
                                            fontSize: fontSize,
                                            top: `${positionY}%`,
                                            left: `${positionX}%`,
                                            width: `${divider}px`,
                                            height: `${divider}px`,
                                            background: `${color}`
                                        }}
                                    >{data.v}
                                        <div className="hoveredItem">{data.v}</div>
                                    </SensorDataItemStyled>
                                );
                            })}
                        </Paper>
                    </SensorBoxStyled>
                </WrapperStyled>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SensorTestDialog;